import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AuthenticationComponent } from './components/authentication.component';
import { SharedModule } from '../shared-module/shared.module';
import { NgxCaptchaModule } from 'ngx-captcha';
import {
  CrematoriumForgotEmailComponent,
  CrematoriumLoginComponent,
  CrematoriumSignUpComponent,
  FloristForgotEmailComponent,
  FloristLoginComponent,
  FloristSignUpComponent,
  PanditForgotEmailComponent,
  PanditLoginComponent,
  PanditSetPasswordComponent,
  PanditSignUpComponent,
  TempleForgotEmailComponent,
  TempleLoginComponent,
  TempleSignUpComponent,
  UserForgotEmailComponent,
  UserLoginComponent,
  UserSetPasswordComponent,
  UserSignUpComponent,
} from './components';
import { SocialLoginsComponent } from './components/social-logins/social-logins.component';


@NgModule({
  declarations: [
    PanditForgotEmailComponent,
    PanditSetPasswordComponent,
    UserForgotEmailComponent,
    UserSetPasswordComponent,
    PanditLoginComponent,
    PanditSignUpComponent,
    UserSignUpComponent,
    UserLoginComponent,
    AuthenticationComponent,
    CrematoriumLoginComponent,
    CrematoriumSignUpComponent,
    FloristLoginComponent,
    FloristSignUpComponent,
    CrematoriumForgotEmailComponent,
    FloristForgotEmailComponent,
    TempleSignUpComponent,
    TempleLoginComponent,
    TempleForgotEmailComponent,
    SocialLoginsComponent
  ],

  imports: [
    CommonModule,
    SharedModule,
    NgxCaptchaModule,
    AuthenticationRoutingModule,
  ],
})

export class AuthenticationModule {}
